import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { LogoMark } from "../site/Logo";

export const LoginCard = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md border border-[#D4AF37]/25 bg-[#0E081D] p-8 sm:p-10">
        <LogoMark className="h-12 w-12" />
        <h1 className="font-display mt-6 text-4xl text-white">Bookings Dashboard</h1>
        <p className="mt-2 flex items-center gap-2 text-sm text-slate-400"><Lock className="h-3.5 w-3.5" /> Private admin access</p>
        <div className="mt-8 space-y-4">
          <input required type="email" placeholder="Admin email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" aria-label="Email" />
          <input required type="password" placeholder="Password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" aria-label="Password" />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
          className="mt-8 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#D4AF37] font-medium text-[#07040D] transition-colors hover:bg-[#F3E5AB] disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};
